<template>
  <div class="chat-leftsidebar overflow-auto">
    <div class="tab-content">
      <!-- Start Profile tab-pane -->
      <elProfile />
      <!-- End Profile tab-pane -->

      <!-- Start chats tab-pane -->
      <elRooms />
      <!-- End chats tab-pane -->

      <!-- Start contacts tab-pane -->
      <elMembers />
      <!-- End contacts tab-pane -->

      <!-- Start settings tab-pane -->
      <elSetting />
      <!-- End settings tab-pane -->
    </div>
    <!-- end tab content -->
  </div>
</template>

<script>
import elProfile from "./Profile";
import elRooms from "./Rooms";
import elMembers from "./Members";
import elSetting from "./Setting";
export default {
  name: "LeftSidebar",

  components: {
    elProfile,
    elRooms,
    elMembers,
    elSetting,
  },

  data() {
    return {};
  },

  mounted() {
    this.$nextTick(() => {
    });
  },
  methods: {},
};
</script>
